// src/components/CarNavbar.jsx
import React, { useState, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";

import carelliLogo from "../img/Logo.png";
import carelliLogo2 from "../img/carelliLogo2.png";
import Instagram from "../img/Instagram.png";
import Facebook from "../img/Facebook.png";
import LinkedIn from "../img/LinkedIn.png";

import "../styles/CarNavbar.css";

const navLinksLeft = [
  { to: "/azienda", label: "Azienda" },
  { to: "/insegne-mappa", label: "Punti Vendita" },
  { to: "/logistica", label: "Logistica" },
  { to: "/approccio", label: "Cash&Carry" },
];
const navLinksRight = [
  { to: "/volantino", label: "Volantino" },
  { to: "https://www.primo-prezzo.it/", label: "Spesa Online", out: '_blank'},
  { to: "/pagina-dei-contatti", label: "Contattaci" },
  { to: "https://www.carellijob.it/", label: "Lavora con noi", linkClass: 'btn-white', out: '_blank'},
];
// usiamo questi per il menu mobile
const navLinksMobile = [...navLinksLeft, ...navLinksRight];
const socialLinks = [
  { href: "https://www.instagram.com", imgSrc: Instagram, alt: "Instagram" },
  { href: "https://www.facebook.com", imgSrc: Facebook, alt: "Facebook" },
  { href: "https://www.linkedin.com", imgSrc: LinkedIn, alt: "LinkedIn" },
];

const CarNavbar = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // blocca lo scroll del body quando aperto


  useEffect(() => {
    const handleResize = () => {
      // se sono su desktop >1200px, chiudo il menu
      if (window.innerWidth > 1200) {
        setShow(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [show]);

  return (
    <>
      <nav className="car-navbar">
        {/* links desktop left */}
        <div className="nav-left d-xl-flex">
          {navLinksLeft.map(({ to, label }) => (
            <Link key={to} to={to} className="nav-link">
              {label}
            </Link>
          ))}
        </div>

        {/* logo sempre al centro */}
        <div className="nav-center">
          <Link to="/">
            <img src={carelliLogo} alt="Logo" className="logo-desktop" />
            <img src={carelliLogo} alt="Logo mobile" className="logo-mobile" />
          </Link>
        </div>

        {/* links desktop right */}
        <div className="nav-right d-xl-flex">
          {navLinksRight.map(({ to, label, linkClass, out  }) => (
            <Link target={out ?? '_self'} key={to} to={to} className="nav-link">
              <div className={`${linkClass ? " " + linkClass : ""}`} >
                {label}
              </div>
            </Link>
          ))}
        </div>

        {/* hamburger mobile */}
        <button
          className="hamburger d-xl-none"
          onClick={handleShow}
          aria-label="Apri menu"
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
      </nav>

      {/* Offcanvas laterale */}
      <Offcanvas show={show} onHide={handleClose} placement="start">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title><img style={{width:'150px'}} src={carelliLogo} alt="Logo" className="pt-3 ps-3" /></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="mobile-nav-links">
            {navLinksMobile.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className="mobile-nav-link"
                onClick={handleClose}
              >
                {label}
              </Link>
            ))}
          </div>
          <div
          style={{borderTop:'1px solid black'}}
          className="mobile-social-links mt-4 d-flex gap-3 pt-3">
            {socialLinks.map(({ href, imgSrc, alt }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClose}
              >
                <img src={imgSrc} alt={alt} className="social-icon" />
              </a>
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default CarNavbar;
